module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAYAAAAe2bNZAAAAIGNIUk0AAG4nAABzrwAA+3sAAIFIAABs7gAA5xMAAC5xAAAZsJP3gzMAAAC9SURBVEjH7dY9CgIxEIbhVMJ6FbN3jY3saSys33Ih3kMLVwyxycKykICYgSmm+JowkCdk8uNyzk5LnGEMYxjDaMAA+5yAAETgVRLLmN/XS2EGYAISkCtJpWaQxByAawOxzw04SmEuP0DWTBIYD3wqE67Y2pb53pjQWH0Lk4HQGxP/wMTemKUCqGVbu2jCPDRt06ypgc8SRztpOdqqLj11z4Gqh3KbsTT1HXgDT2AuY6PoF8J+eoYxjGEMI5AvOUFgKMCzkLwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/plus-icon.png
// module id = 254
// module chunks = 0